const PREFIX = 'curriculum_progress_v1_';

function storageKey(langPair, level) {
  return `${PREFIX}${langPair || 'guest'}_${String(level || '').toLowerCase()}`;
}

function readCompleted(langPair, level) {
  try {
    const value = JSON.parse(localStorage.getItem(storageKey(langPair, level)) || '[]');
    return Array.isArray(value)
      ? [...new Set(value.map(Number).filter((day) => Number.isInteger(day) && day > 0))].sort((a, b) => a - b)
      : [];
  } catch {
    return [];
  }
}

function notify(langPair, level) {
  window.dispatchEvent(new CustomEvent('curriculum-progress-changed', {
    detail: { langPair, level },
  }));
}

export const CurriculumProgressService = {
  snapshot(langPair, level, totalDays) {
    const completedDays = readCompleted(langPair, level).filter((day) => day <= totalDays);
    const nextDay = Array.from({ length: totalDays }, (_, index) => index + 1)
      .find((day) => !completedDays.includes(day)) || null;
    return {
      completedDays,
      completedCount: completedDays.length,
      nextDay,
      percent: totalDays ? Math.round((completedDays.length / totalDays) * 100) : 0,
      isComplete: totalDays > 0 && completedDays.length >= totalDays,
    };
  },

  completeDay(langPair, level, day, totalDays) {
    const current = readCompleted(langPair, level);
    const numericDay = Number(day);
    if (!Number.isInteger(numericDay) || numericDay < 1 || numericDay > totalDays) {
      return this.snapshot(langPair, level, totalDays);
    }
    const snapshot = this.snapshot(langPair, level, totalDays);
    if (numericDay !== snapshot.nextDay && !snapshot.completedDays.includes(numericDay)) {
      return snapshot;
    }
    if (!current.includes(numericDay)) {
      localStorage.setItem(storageKey(langPair, level), JSON.stringify([...current, numericDay].sort((a, b) => a - b)));
      notify(langPair, level);
    }
    return this.snapshot(langPair, level, totalDays);
  },

  isUnlocked(day, snapshot) {
    return snapshot.completedDays.includes(day) || snapshot.nextDay === day;
  },
};
